import React, { useState, useEffect } from 'react';
import api from '../../api/api';
import './RankShowcase.css';
import airlineConfig from '../../config/airlineConfig';

const RankShowcase = () => {
  const [ranks, setRanks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRanks = async () => {
      try {
        const response = await api.get('/ranks');
        // Sort ranks by hours and assign level for stripe display
        const sortedRanks = response.data
          .sort((a, b) => a.hours - b.hours)
          .map((rank, index) => ({
            ...rank,
            level: index + 1 // Level 1-N for stripe display
          }));
        setRanks(sortedRanks);
      } catch (error) {
        console.error('Error fetching ranks:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRanks();
  }, []);

  if (loading) {
    return <div className="rank-showcase">Loading ranks...</div>;
  }

  return (
    <div className="rank-showcase">
      <h2>Sistema de Rangos - {airlineConfig.name}</h2>
      <div className="ranks-grid">
        {ranks.map(rank => (
          <div key={rank.id} className="rank-card">
            {rank.img && (
              <img
                src={rank.img}
                alt={rank.name}
                className="rank-medal"
                style={{ height: '80px', width: 'auto', marginBottom: '10px' }}
              />
            )}
            <div className="rank-details">
              <h3>{rank.name}</h3>
              <p>{rank.hours} horas / {rank.flights || 0} vuelos</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RankShowcase;